// Frontend-version av samma policy som backend (måste matcha password_policy.py).
export const MIN_LENGTH = 12;

const CHECKS = [
  { label: `Minst ${MIN_LENGTH} tecken`, test: (p) => (p || '').length >= MIN_LENGTH },
  { label: 'Minst 1 versal (A-Ö)', test: (p) => /[A-ZÅÄÖ]/.test(p || '') },
  { label: 'Minst 1 gemen (a-ö)', test: (p) => /[a-zåäö]/.test(p || '') },
  { label: 'Minst 1 siffra', test: (p) => /\d/.test(p || '') },
  { label: 'Minst 1 specialtecken (!@#$...)', test: (p) => /[!@#$%^&*(),.?":{}|<>+\-=_~`'/\[\];]/.test(p || '') },
];

export const evaluatePassword = (pw) => CHECKS.map((c) => ({ label: c.label, ok: c.test(pw) }));
export const isPasswordStrong = (pw) => CHECKS.every((c) => c.test(pw));
